<template>
  <div class="big">
    <div class="container">
      <div class="searchbox">
        <div>
          <span style="margin-right:10px">启用状态</span>
          <el-radio-group
            v-model="status"
            @change="getList"
          >
            <el-radio :label="''">全部</el-radio>
            <el-radio :label="1">已启用</el-radio>
            <el-radio :label="0">已禁用</el-radio>
          </el-radio-group>
        </div>
        <el-button
          type="primary"
          @click="openAddDia"
          style="width: 120px"
          :disabled="
                  module_id_array[0] ? !module_id_array.includes('1361') : false
                "
        >添加筛选标签</el-button>
      </div>
      <div style="border: solid 1px #c9cbd6">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%; min-width: 1000px"
          :header-cell-style="{ background: '#F5F5F5' }"
        >
          <el-table-column
            label="标签名"
            prop="label_name"
          ></el-table-column>
          <el-table-column label="医生来源">
            <template slot-scope="scope">
              <div>
                <span v-if="scope.row.label_from==1">手动标签</span>
                <span v-if="scope.row.label_from==2">自动标签</span>
              </div>
              <div>
                {{scope.row.label_type}}/{{scope.row.label_type_name}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="医生人数"
            prop="doctor_count"
          ></el-table-column>
          <el-table-column label="启用状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status==1">已启用</span>
              <span v-if="scope.row.status==0">已禁用</span>
            </template>
          </el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="toDetail(scope.row)"
                :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('1364')
                          : false
                      "
              >详情</el-button>
              <el-button
                v-if="scope.row.status==0"
                type="text"
                @click="editDia(scope.row)"
                :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('1362')
                          : false
                      "
              >编辑</el-button>
              <el-button
                v-if="scope.row.status==1"
                type="text"
                @click="editStatus(scope.row.label_id,0)"
                :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('1360')
                          : false
                      "
              >禁用</el-button>
              <el-button
                v-if="scope.row.status==0"
                type="text"
                @click="editStatus(scope.row.label_id,1)"
                :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('1360')
                          : false
                      "
              >启用</el-button>
              <el-button
                v-if="scope.row.status==0"
                type="text"
                @click="delLabel(scope.row.label_id)"
                :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('1389')
                          : false
                      "
              >删除</el-button>
            </template>
          </el-table-column>

          <el-table-column
            label="排序"
            width="200px"
            align="center"
          >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                content="置顶"
                placement="top"
              >
                <el-button
                  @click="updateSort(scope.$index, 1)"
                  size="medium"
                  type="text"
                  icon="el-icon-upload2"
                  :disabled="module_id_array[0] ? !module_id_array.includes('1363'): false "
                  style="font-size: 20px"
                ></el-button>
              </el-tooltip>

              <el-tooltip
                class="item"
                effect="dark"
                content="置底"
                placement="top"
              >
                <el-button
                  @click="updateSort(scope.$index, 2)"
                  size="medium"
                  type="text"
                  icon="el-icon-download"
                  :disabled="module_id_array[0] ? !module_id_array.includes('1363') : false"
                  style="font-size: 20px"
                ></el-button>
              </el-tooltip>

              <el-tooltip
                class="item"
                effect="dark"
                content="上移"
                placement="top"
              >
                <el-button
                  @click="updateSort(scope.$index, 3)"
                  size="medium"
                  type="text"
                  icon="el-icon-top"
                  :disabled="module_id_array[0] ? !module_id_array.includes('1363') : false "
                  style="font-size: 20px"
                ></el-button>
              </el-tooltip>

              <el-tooltip
                class="item"
                effect="dark"
                content="下移"
                placement="top"
              >
                <el-button
                  @click="updateSort(scope.$index, 4)"
                  size="medium"
                  type="text"
                  icon="el-icon-bottom"
                  :disabled="module_id_array[0] ? !module_id_array.includes('1363') : false"
                  style="font-size: 20px"
                ></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog
      :visible.sync="addDia"
      width="600px"
      :title="title"
    >
      <div class="mydia">
        <div>
          <span class="title">
            <span style="color:red">*</span>
            <span>标签名</span>
          </span>
          <el-input
            v-model="addData.label_name"
            style="width:200px"
            maxlength="10"
          ></el-input>
        </div>
        <div style="margin:20px 0">
          <span class="title">
            <span style="color:red">*</span>
            <span>医生来源</span>
          </span>
          <el-radio-group
            v-model="addData.label_from"
            @change="getTypeList"
          >
            <el-radio :label="1">手动标签</el-radio>
            <el-radio :label="2">自动标签</el-radio>
          </el-radio-group>
        </div>
        <div>
          <span class="title">
            <span style="color:red">*</span>
            <span>标签</span>
          </span>
          <el-select
            v-model="addData.label_category_type"
            placeholder="请选择"
            style="width:200px"
            @change="changeLabel"
          >
            <el-option
              v-for="item in labelTypeList"
              :key="item.label_type"
              :label="item.label_type_name"
              :value="item.label_type"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="addData.platform_label_id"
            placeholder="请选择"
            style="width:200px;margin-left:10px"
            v-if="addData.label_category_type"
          >
            <el-option
              v-for="item in labelList"
              :key="item.label_id"
              :label="item.label_name"
              :value="item.label_id"
            >
            </el-option>
          </el-select>
        </div>

        <div style="text-align:center;margin:30px 0 10px">
          <el-button
            type="primary"
            size="medium"
            style="width: 92px"
            @click="sumbit"
          >提交</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [],
      status: '',
      labelTypeList: [],
      labelList: [],
      addDia: false,
      title: '添加筛选标签',
      addData: {
        label_name: '',
        label_from: 1,
        label_category_type: '',
        platform_label_id: ''
      }
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        status: this.status
      };
      this.axios
        .post('platform/Doctor/getDoctorLabelCheckList', data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list;
          }
        });
    },
    //排序
    updateSort(index, sort) {
      if (this.tableData.length == 1) {
        this.$message.warning('只有一条数据噢');
        return false;
      }
      let data = this.tableData[index];
      this.tableData.splice(index, 1);
      //置顶
      if (sort == 1) {
        this.tableData.splice(0, 0, data);
      }
      //置底
      if (sort == 2) {
        this.tableData.push(data);
      }
      //上移
      if (sort == 3) {
        this.tableData.splice(index - 1, 0, data);
      }
      //下移
      if (sort == 4) {
        this.tableData.splice(index + 1, 0, data);
      }
      let list = [];
      list = this.tableData.map((item) => {
        item = _.pick(item, ['label_id', 'sort']);
        return item;
      });
      this.axios
        .post('platform/Doctor/setDoctorLabelCheckSort', { list })
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('保存成功');
            this.getList();
          }
        });
    },
    openAddDia() {
      this.getTypeList(1);
      this.title = '添加筛选标签';
      this.addData = {
        label_name: '',
        label_from: 1,
        label_category_type: '',
        platform_label_id: ''
      };
      this.addDia = true;
    },
    editDia(row) {
      let loading = this.$loading();
      this.title = '编辑筛选标签';
      this.getTypeList(row.label_from);
      this.changeLabel(row.label_category_type);
      setTimeout(() => {
        this.addData = {
          label_name: row.label_name,
          label_from: row.label_from,
          label_category_type: row.label_category_type,
          platform_label_id: row.platform_label_id,
          label_id: row.label_id
        };
        loading.close();
        this.addDia = true;
      }, 1000);
    },
    //更改自动  手动
    getTypeList(value) {
      this.addData.label_category_type = '';
      this.addData.platform_label_id = '';
      let type = value == 1 ? 2 : 3;
      this.axios.post('platform/Admin/getLabelType', { type }).then((res) => {
        if (res.code == 0) {
          this.labelTypeList = res.data.list;
        }
      });
    },
    //更改标签类型
    changeLabel(value) {
      this.addData.platform_label_id = '';
      let data = {
        type: this.addData.label_from == 1 ? 2 : 3,
        label_type: value
      };
      this.axios.post('platform/Admin/getLabel', data).then((res) => {
        if (res.code == 0) {
          this.labelList = res.data.list;
        }
      });
    },
    //提交
    sumbit() {
      if (
        !this.addData.label_name ||
        !this.addData.label_category_type ||
        !this.addData.platform_label_id
      ) {
        this.$message.error('请完善标签信息!');
        return false;
      }
      let data = this.addData;
      let url = 'platform/Doctor/addDoctorLabelCheck';
      if (this.title == '编辑筛选标签') {
        url = 'platform/Doctor/updateDoctorLabelCheck';
      }
      this.axios.post(url, data).then((res) => {
        if (res.code == 0) {
          this.$message.success('保存成功');
          this.addDia = false;
          this.getList();
        }
      });
    },
    //详情
    toDetail(row) {
      this.$router.push({
        path: 'picklabeldetail',
        query: {
          label_id: row.label_id,
          label_name: row.label_name,
          label_type: row.label_type,
          label_type_name: row.label_type_name
        }
      });
    },
    //禁用 启用
    editStatus(label_id, status) {
      let msg = '禁用';
      if (status) {
        msg = '启用';
      }
      this.$confirm(`确定${msg}该标签吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.axios
            .post('platform/Doctor/updateDoctorLabelCheckStatus', {
              label_id,
              status
            })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('状态修改成功');
                this.getList();
              }
            });
        })
        .catch(() => {});
    },
    //删除
    delLabel(label_id) {
      this.$confirm('确定删除该标签吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.axios
            .post('platform/Doctor/deleteDoctorLabelCheck', { label_id })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('删除成功');
                this.getList();
              }
            });
        })
        .catch(() => {});
    }
  },
  activated() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.searchbox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.imgbox {
  display: flex;
  box-sizing: border-box;
  text-align: center;
}
.uploadimg {
  width: 120px;
  height: 120px;
  box-sizing: border-box;
  background-color: #fff;
  border: dashed 1px #d6d6d6;
  .avatar {
    width: 120px;
    height: 120px;
  }
  .uploader-icon {
    padding-top: 10px;
    line-height: 20px;
    color: #669961;
  }
}
.mydia {
  text-align: left;
  padding: 20px;
  box-sizing: border-box;
  .title {
    display: inline-block;
    width: 90px;
    text-align: right;
    margin-right: 10px;
  }
}
</style>